// extracted by mini-css-extract-plugin
export default {"adminDashboardContainer":"AdminDashboard_adminDashboardContainer__7LKGo"};